import { postDeck } from "../apiCalls";
import { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'



function NewDeckComp(props) {
    const setNewDeckToggle = props.mods.setNewDeckToggle
    const getDecks = props.mods.getDecks

    const [newDeckForm, setNewDeckForm] = useState({
        name: "",
    })

    function handleChange(e) {
        setNewDeckForm((baseState) => ({
            ...baseState,
            [e.target.name]: e.target.value
        }))
    }


    function handleClose() {
        setNewDeckToggle(false)
    }

    async function handleSubmit(e) {
        e.preventDefault()
        await postDeck(newDeckForm)
        e.target.reset()
        getDecks()
        setNewDeckToggle(false)
    }

    return (
        <div className="newDateContainer">
            <i className="bi bi-x-square closeIcon" onClick={handleClose}></i>
            <Container>
                <h2 className="">New Deck</h2>
                <Form onSubmit={handleSubmit}>
                <Row>
                    <Form.Group className="sm-2" controlId="ideaName">
                        <Form.Label>Name: </Form.Label>
                        <Form.Control type='text' name="name" onChange={handleChange}></Form.Control>
                    </Form.Group>
                </Row>
                <Row className="inputButtonRow mt-2">
                    <Col className="d-flex justify-content-center">
                        <Button variant="dark" type="submit" className="defaultButton">Submit</Button>
                    </Col>
                </Row>
                </Form>
            </Container>
        </div>
    )
}

export default NewDeckComp